import { Get } from '../helpers';
import type { GraphicInterface } from '@/types/greenroom/graphics.types';

const LoadGraphics = async (meetingId: number, token: string): Promise<GraphicInterface[]> => {
  const url = `${import.meta.env.VITE_GREENROOM_API}/v2/greenroom/graphics/${meetingId}`;
  return Get({
    path: url,
    headers: {
      'bl-token': token,
      'bl-global-resource': 'false',
    },
  });
};

export default LoadGraphics;
